var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Pivot',{attrs:{"statisticData":_vm.statisticData,"filter-default-values":_vm.filterDefaultValues,"filters":_vm.filters,"rows":_vm.rows,"values":_vm.values,"title":"Services"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }